import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../Services/auth';
import { AlertService } from '../Services/alert';
import { User } from '../Models/user';
import { Credentials } from '../Models/credentials';


@Component({
  selector: 'app-login',
  templateUrl: '../Templates/login.component.html',
})


export class LoginComponent implements OnInit {

  public model: Credentials;
  public form_error: string;

  @Output() loggedin: EventEmitter<User> = new EventEmitter();

  constructor(private authService: AuthService,
              private msg: AlertService) {
  }

  ngOnInit() {
    this.model = new Credentials();
  }

  logged_in(user): void {
    this.loggedin.emit(user);
    this.msg.success("Hi " + user.email);
  }

  login(): void {

    this.authService.login(this.model).subscribe(
      user => {this.logged_in(user)},
      (err: HttpErrorResponse) => {
        if (err.error.non_field_errors) {
          this.form_error = err.error.non_field_errors;
        } else {
          this.form_error = err.error;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/login.ts